export default __webpack_public_path__ + "static/media/extrovert.d1515cc1.svg";